module.exports = __webpack_public_path__ + "img/LOTERIA_WINNERHEADER.93f1f139.png";